import React from "react";
import Projects from "../../api/gallery";
import SectionTitle from "../SectionTitle/SectionTitle";

const ProjectSectionAbout = (props) => {
    const { hclass, ShowSectionTitle = true, sliceStart = 0, sliceEnd = 6, } = props;
    return (
      <section className={hclass}>
        <div className="container">
          {ShowSectionTitle && (
            <div className="row align-items-center">
              <div className="col-lg-12 col-12">
                <SectionTitle
                  title={"Nuestros espacios"}
                  subtitle={
                    "Todo lo necesario para intervenciones quirúrgicas avanzadas a tu disposición: desde los quirófanos y áreas de recuperación, hasta nuestro equipo quirúrgico. "
                  }
                />
              </div>
            </div>
          )}
          <div className="project_wrapper">
            <div className="row">
              {Projects.slice(sliceStart, sliceEnd).map((project, pitem) => {
                // Determinar si es imagen horizontal basándose en el aspect ratio
                const isHorizontal =
                  project.orientation === "horizontal" ||
                  project.orientation === "wide";
                const colClass = isHorizontal
                  ? "col-lg-8 col-md-8 col-12"
                  : "col-lg-4 col-md-6 col-12";
                const imgClass = isHorizontal ? "horizontal-img" : "";

                return (
                  <div className={colClass} key={pitem}>
                    <div className="project_card">
                      <img src={project.pimg1} alt="" className={imgClass} />
                      <div className="text">
                        <h2>{project.title}</h2>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    );
}
export default ProjectSectionAbout;





